import script from "./core-services.vue?vue&type=script&lang=ts&setup=true"
export * from "./core-services.vue?vue&type=script&lang=ts&setup=true"

import "./core-services.vue?vue&type=style&index=0&id=52f456a0&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f456a0"]])

export default __exports__